<template>
  <section class="section auth-section">
    <div class="box auth-card">

      <h1 class="title is-4 has-text-centered mb-2">
        Reset your password
      </h1>

      <p class="subtitle is-6 has-text-centered mb-5 mt-2">
        Enter your email and we'll send you reset instructions.
      </p>

      <form @submit.prevent="handleSubmit">

        <b-field label="Email address" :type="emailState" :message="emailError">
          <b-input v-model.trim="form.email" placeholder="user@email.com" icon="email"
            :icon-right="isEmailValid && touched ? 'check-circle' : ''"
            :icon-right-type="isEmailValid && touched ? 'is-success' : ''" size="is-medium" @input="touched = true" />
        </b-field>

        <b-button expanded type="is-primary" size="is-medium" :loading="loading" native-type="submit" class="mt-4"
          :disabled="!isEmailValid || loading">
          Send reset link
        </b-button>

      </form>

      <p class="has-text-centered is-size-7 mt-4 mb-5">
        Remembered your password?
        <router-link :to="{ name: 'Login' }">
          Sign in
        </router-link>
      </p>

      <!-- Divider -->
      <div class="info-divider"></div>

      <!-- Information Section -->
   <div class="info-section">

  <h4 class="info-title clickable" @click="showHelp = !showHelp">
    Didn’t receive the email?
  </h4>

  <div v-if="showHelp">

    <ul class="info-list">
      <li>Check your spam or junk folder</li>
      <li>Make sure you entered the correct email address</li>
      <li>Wait a few minutes and try again</li>
      <li>Ensure your mailbox is not full</li>
    </ul>

    <p class="info-footer">
      Still having trouble?
      <a href="mailto:support@quickadmit.com
        ?subject=Password Reset Assistance
        &body=Hi QuickAdmit Support,%0D%0A%0D%0AI am having trouble resetting my password.%0D%0A%0D%0AEmail used: "
        class="support-link">
        Contact support
      </a>
    </p>

  </div>

</div>

    </div>
  </section>
</template>

<script>
import Form from '../utils/form';

export default {
  name: 'PasswordReset',
  data() {
    return {
      loading: false,
      touched: false,
      showHelp: false,
      form: new Form({ email: '' }),
    };
  },

  computed: {
    isEmailValid() {
      const email = this.form.email;
      if (!email) return false;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    emailState() {
      if (!this.touched) return '';

      if (!this.form.email || !this.isEmailValid) {
        return 'is-danger';
      }

      return 'is-success';
    },

    emailError() {
      if (!this.touched) return '';

      if (!this.form.email) {
        return 'Email is required';
      }

      if (!this.isEmailValid) {
        return 'Please enter a valid email address';
      }

      return '';
    }
  },

  methods: {
    handleSubmit() {
      this.touched = true;

      if (!this.isEmailValid) return;

      this.loading = true;

      this.form
        .post('/auth/password/reset')
        .then(() => {
          let msg =
            'If that email is in our system, instructions to reset your password have been sent to it.';
          this.$buefy.toast.open({ message: msg, type: 'is-success', duration: 10000 });
          this.$router.push({ name: 'PasswordResetRequestSent' });
        })
        .catch(() => {
          if (!this.form.errors.any()) {
            this.form.errors.setGenericError();
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.auth-card {
  padding: 2.5rem;
  border-radius: 14px;
  max-width: 460px;
  margin: auto;
}

/* Divider */
.info-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 1.5rem 0;
}

/* Info Section */
.info-section {
  font-size: 0.9rem;
  color: #6b7280;
}

.info-title {
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #374151;
}

.info-list {
  padding-left: 1.2rem;
  margin-bottom: 1rem;
}

.info-list li {
  margin-bottom: 0.5rem;
}

.info-footer {
  font-size: 0.85rem;
}

.info-section {
  background: #f9fafb;
  padding: 1rem;
  border-radius: 10px;
}

.support-link {
  color: #7957d5;
  /* your brand purple */
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.support-link:hover {
  text-decoration: underline;
  opacity: 0.85;
}

.clickable {
  cursor: pointer;
}
</style>